// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IHealthPlanTierFamilyCountDto } from './IHealthPlanTierFamilyCountDto';
import {
    IHealthPlanTierFamilyCountDtoFromJSON,
    IHealthPlanTierFamilyCountDtoFromJSONTyped,
    IHealthPlanTierFamilyCountDtoToJSON,
    IHealthPlanTierFamilyCountDtoToJSONTyped,
} from './IHealthPlanTierFamilyCountDto';

/**
 * 
 * @export
 * @interface IHealthPlanTierStatsDto
 */
export interface IHealthPlanTierStatsDto {
    /**
     * 
     * @type {number}
     * @memberof IHealthPlanTierStatsDto
     */
    health_plan_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanTierStatsDto
     */
    health_plan_name?: string;
    /**
     * 
     * @type {Array<IHealthPlanTierFamilyCountDto>}
     * @memberof IHealthPlanTierStatsDto
     */
    tiers?: Array<IHealthPlanTierFamilyCountDto>;
}

/**
 * Check if a given object implements the IHealthPlanTierStatsDto interface.
 */
export function instanceOfIHealthPlanTierStatsDto(value: object): value is IHealthPlanTierStatsDto {
    return true;
}

export function IHealthPlanTierStatsDtoFromJSON(json: any): IHealthPlanTierStatsDto {
    return IHealthPlanTierStatsDtoFromJSONTyped(json, false);
}

export function IHealthPlanTierStatsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IHealthPlanTierStatsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'health_plan_id': json['health_plan_id'] == null ? undefined : json['health_plan_id'],
        'health_plan_name': json['health_plan_name'] == null ? undefined : json['health_plan_name'],
        'tiers': json['tiers'] == null ? undefined : ((json['tiers'] as Array<any>).map(IHealthPlanTierFamilyCountDtoFromJSON)),
    };
}

export function IHealthPlanTierStatsDtoToJSON(json: any): IHealthPlanTierStatsDto {
    return IHealthPlanTierStatsDtoToJSONTyped(json, false);
}

export function IHealthPlanTierStatsDtoToJSONTyped(value?: IHealthPlanTierStatsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'health_plan_id': value['health_plan_id'],
        'health_plan_name': value['health_plan_name'],
        'tiers': value['tiers'] == null ? undefined : ((value['tiers'] as Array<any>).map(IHealthPlanTierFamilyCountDtoToJSON)),
    };
}

